<template>
  <div class="vch-create-account">
    <div class="vch-create-account-title">
      <h1 class="vch-create-account__title heading-xl uppercase">
        {{ currentTitle }}
        <span class="heading-xl mb-xl sub-heading"> {{ titleSecondary }}</span>
      </h1>
    </div>
    <template v-if="!formSuccess">
      <div class="vch-grid">
        <div
          class="
            vch-col-12
            vch-col-md-10
            vch-col-offset-md-1
            vch-col-lg-8
            vch-col-offset-lg-2
            vch-col-xl-6
            vch-col-offset-xl-3
          "
        >
          <p class="vch-contact-form__instructions">
            {{ formMandatoryInstruction }}
          </p>
          <slot name="form">Form Here</slot>
          <input
            id="psws"
            type="hidden"
            @input="validatePass"
            maxlength="255"
            data-sc-tracking="True"
            data-sc-field-name="password"
            data-sc-field-key="C6352CC9A60749BC9C6FF3F3059937C8"
            data-val-required="Password* is required."
            data-val="true"
            class="vch-form-field --name-field psw"
          />
        </div>
      </div>
    </template>
    <template v-else>
      <h2 class="heading-lg uppercase mb-xxs">
        <span class="heading-lg-em">{{ completeTitlePrimary }}</span
        ><br />{{ completeTitleSecondary }}
      </h2>
      <p class="heading-md mb-xl" v-html="completeMessage"></p>
      <a
        href="/"
        class="button -primary --fit-content"
        @click="pushReturnTag"
        >{{ confirmButtonText }}</a
      >
    </template>
  </div>
</template>
<script>
import { parseSitecoreForm, bindFormField } from 'Utils/form';
import { mixinFormRecaptcha } from 'Mixins/formRecaptcha/formRecaptcha';
import { pushEvent } from 'Utils/datalayer';

export default {
  name: 'vch-create-account',
  mixins: [mixinFormRecaptcha],
  props: {
    formTitle: {
      type: String,
      required: true,
    },
    formMandatoryInstruction: {
      type: String,
    },
    titleSubheading: {
      type: String,
      required: true,
    },
    testHost: {
      type: String,
      required: false,
    },
    confirmTitlePrimary: {
      type: String,
      required: true,
    },
    confirmTitleSecondary: {
      type: String,
      required: true,
    },
    confirmMessage: {
      type: String,
      required: true,
    },
    confirmTitleNewsletterPrimary: {
      type: String,
      required: true,
    },
    confirmTitleNewsletterSecondary: {
      type: String,
      required: true,
    },
    confirmNewsletterMessage: {
      type: String,
      required: true,
    },
    confirmButtonText: {
      type: String,
      required: true,
    },
    errorMessageFormIncomplete: {
      type: String,
      required: true,
    },
    errorMessageFormTerms: {
      type: String,
      required: true,
    },
    defaultErrorMessage: {
      type: String,
      required: false,
      default: 'An error occured while processing your request.',
    },
    formDatalayer: {
      type: String,
      required: false,
    },
    formDatalayerNewsletter: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      currentTitle: this.formTitle,
      titleSecondary: this.titleSubheading,
      formSuccess: false,
      useEmailFlow: false,
      fields: [],
      formProperties: null,
      parser: new DOMParser(),
      errorWrapperNode: null,
      password: '',
      showPasswordExpectations: false,
      passwordLength: false,
      passwordDigit: false,
      passwordCapital: false,
      showError: false,
      pwdcharacterLimit: false,
      pwdSpecialChar: false,
      pwdUppercase: false,
      pwdSmallcase: false,
      pwdLength: false,
      confirmPassword: false,
      datalayerForm: null,
      newsletterDatalayerForm: null,
    };
  },
  computed: {
    completeTitleSecondary() {
      return this.titleSecondary;
    },
    completeTitlePrimary() {
      return this.useEmailFlow
        ? this.confirmTitleNewsletterPrimary
        : this.confirmTitlePrimary;
    },
    completeMessage() {
      return this.useEmailFlow
        ? this.confirmNewsletterMessage
        : this.confirmMessage;
    },
    formActionUrl() {
      return process.env.NODE_ENV === 'production'
        ? this.formProperties.formAction
        : `${this.testHost}${this.formProperties.formAction}`;
    },
  },
  mounted() {
    this.datalayerForm = JSON.parse(this.formDatalayer);
    this.newsletterDatalayerForm = JSON.parse(this.formDatalayerNewsletter);
    const formNode = this.$slots.form[0].children[0].children[0];
    if (!formNode?.elm) {
      return;
    }
    // Collect the base form properties and hijack form submit
    this.formProperties = parseSitecoreForm(formNode?.elm);
    formNode.elm.addEventListener('submit', this.onSubmit);

    // Create the error message wrapper
    this.errorWrapperNode = document.createElement('div');
    this.errorWrapperNode.setAttribute('role', 'status');
    this.errorWrapperNode.classList.add('vch-contact-form__errorSummary');
    const submitButton = formNode?.elm.querySelector('input[type="submit"]');
    submitButton.parentNode.insertBefore(this.errorWrapperNode, submitButton);

    // Traverse the form and collect all the inputs into a single list
    formNode.children
      .filter((node) => node.tag === 'div' || node.tag === 'input')
      .forEach((node) => {
        const foundFieldInfo = bindFormField(node);
        if (foundFieldInfo.nestedFieldInfo.length) {
          this.fields.push(...foundFieldInfo.nestedFieldInfo);
        }
        this.fields.push(foundFieldInfo);
      });
    document.querySelector('.psw').addEventListener('input', this.validatePass);
    document
      .querySelector('.confirm_password')
      .addEventListener('input', this.validateConfirmPass);
    this.setupNewsletterToggle();
  },

  methods: {
    validatePass() {
      var myInput = document.querySelector('.psw');
      var capital = document.querySelector('.capital');
      var small = document.querySelector('.small');
      var number = document.querySelector('.number');
      var length = document.querySelector('.length');
      var special = document.querySelector('.special');

      // Validate capital letters
      var upperCaseLetters = /[A-Z]/g;
      if (myInput.value.match(upperCaseLetters)) {
        capital.classList.remove('invalid');
        capital.classList.add('valid');
        this.pwdUppercase = true;
      } else {
        capital.classList.remove('valid');
        capital.classList.add('invalid');
        this.pwdUppercase = true;
      }

      // Validate small letters
      var smallCaseLetters = /[a-z]/g;
      if (myInput.value.match(smallCaseLetters)) {
        small.classList.remove('invalid');
        small.classList.add('valid');
        this.pwdSmallcase = true;
      } else {
        small.classList.remove('valid');
        small.classList.add('invalid');
        this.pwdSmallcase = true;
      }

      // Special chars
      var specialChar = /[^a-zA-Z\d\s]/g;
      if (myInput.value.match(specialChar)) {
        special.classList.remove('invalid');
        special.classList.add('valid');
        this.pwdSpecialChar = true;
      } else {
        special.classList.remove('valid');
        special.classList.add('invalid');
        this.pwdSpecialChar = false;
      }

      // Validate numbers
      var numbers = /[0-9]/g;
      if (myInput.value.match(numbers)) {
        number.classList.remove('invalid');
        number.classList.add('valid');
        this.pwdcharacterLimit = true;
      } else {
        number.classList.remove('valid');
        number.classList.add('invalid');
        this.pwdcharacterLimit = false;
      }

      // Validate length
      if (myInput.value.length >= 12) {
        length.classList.remove('invalid');
        length.classList.add('valid');
        this.pwdLength = true;
      } else {
        length.classList.remove('valid');
        length.classList.add('invalid');
        this.pwdLength = false;
      }
    },
    validateConfirmPass() {
      var confirmPass = document.querySelector('.confirm_password').value;
      var psw = document.querySelector('.psw').value;
      if (confirmPass !== psw) {
        document.getElementsByClassName(
          'confirm_password_error'
        )[0].style.display = 'block';
        this.confirmPassword = false;
      }
      if (confirmPass == psw) {
        document.getElementsByClassName(
          'confirm_password_error'
        )[0].style.display = 'none';
        this.confirmPassword = true;
      }
    },

    validateCheckbox(fieldInfo) {
      if (!fieldInfo.inputElement.checked) {
        const validationError = fieldInfo.inputElement.getAttribute(
          SITECORE_ISCHECKED_ATTRIBUTE
        );
        applyValidationError(
          fieldInfo.inputElement,
          fieldInfo.validationMsgTarget,
          validationError
        );
        return validationError;
      } else {
        clearValidationError(
          fieldInfo.inputElement,
          fieldInfo.validationMsgTarget
        );
      }
      return null;
    },
    async onSubmit(e) {
      e.preventDefault();
      if (
        !this.validateFields() ||
        !this.pwdcharacterLimit ||
        !this.pwdUppercase ||
        !this.pwdLength ||
        !this.confirmPassword ||
        !this.pwdSpecialChar ||
        !this.pwdSmallcase
      ) {
        return; // Validation failed, so prevent form submission
      }
      let submitButton = document.querySelector('.vch-form-submit');
      // Recaptcha Flow via Mixin
      this.peformRecaptcha()
        .then(async (canSubmit) => {
          if (canSubmit) {
            if (submitButton) {
              submitButton.setAttribute('disabled', 'disabled');
            }
            await fetch(this.formActionUrl, {
              method: 'POST',
              mode: process.env.NODE_ENV === 'production' ? 'cors' : 'no-cors',
              body: this.assembleFormData(),
            })
              .then((response) => {
                if (response.status >= 400 && response.status < 600) {
                  throw new Error(this.defaultErrorMessage);
                }
                return response.text();
              })
              .then((response) => {
                const htmlResponse = this.parser.parseFromString(
                  response,
                  'text/xml'
                );
                const errorWrapper = htmlResponse.querySelector(
                  '.validation-summary-errors'
                );
                if (errorWrapper) {
                  const serverErrorMsgs = errorWrapper.querySelectorAll('li');
                  const summaryErrors = Array.from(serverErrorMsgs).map(
                    (msg) => msg.textContent
                  );
                  this.setErrorMessage(summaryErrors[0]);
                  if (submitButton) {
                    submitButton.removeAttribute('disabled');
                  }
                } else {
                  this.formSuccess = true;
                  this.pushSubmitTags();
                  setTimeout(() => {
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth',
                    });
                  }, 100);
                }
              })
              .catch((error) => {
                this.setErrorMessage(error.message);
                if (submitButton) {
                  submitButton.removeAttribute('disabled');
                }
              });
          }
        })
        .catch(() => {
          this.setErrorMessage(this.defaultErrorMessage);
          if (submitButton) {
            submitButton.setAttribute('disabled', 'disabled');
          }
        });
    },
    setErrorMessage(errorMessage) {
      this.errorWrapperNode.innerText = errorMessage;
    },
    setupNewsletterToggle() {
      const newsletterCheckbox = document.querySelector(
        '.vch-input-checkbox.--newsletter'
      );
      newsletterCheckbox?.addEventListener('change', () => {
        this.useEmailFlow = newsletterCheckbox.checked;
      });
    },
    validateFields() {
      const validationErrors = [];
      let hasTermsError = false;
      this.fields.forEach((field) => {
        const fieldErrors = field.validate();
        if (fieldErrors.length) {
          hasTermsError = true;
        }
        validationErrors.push(...fieldErrors);
      });

      if (hasTermsError) {
        this.setErrorMessage(this.errorMessageFormTerms);
        return false;
      } else if (validationErrors.length > 0) {
        this.setErrorMessage(this.errorMessageFormIncomplete);
        return false;
      }
      return true;
    },
    assembleFormData() {
      const formData = new FormData();
      this.fields.forEach((field) => {
        if (field.inputElement) {
          if (field.inputElement.type == 'checkbox') {
            formData.append(
              field.inputElement.name,
              field.inputElement.checked
            );
          } else {
            formData.append(field.inputElement.name, field.inputElement.value);
          }
        }
        field.hiddenFields.forEach((hiddenField) => {
          if (hiddenField.name) {
            formData.append(hiddenField.name, hiddenField.value);
          }
        });
      });
      return formData;
    },
    pushSubmitTags() {
      if (this.useEmailFlow) {
        pushEvent({
          event: this.newsletterDatalayerForm?.data?.eventProperties?.event,
          event_name:
            this.newsletterDatalayerForm?.data?.eventProperties?.event_name,
          ecommerce:
            this.newsletterDatalayerForm?.data?.eventProperties?.ecommerce,
          eventCategory:
            this.newsletterDatalayerForm?.data?.eventProperties?.eventCategory,
          eventAction:
            this.newsletterDatalayerForm?.data?.eventProperties?.eventAction,
          eventLabel:
            this.newsletterDatalayerForm?.data?.eventProperties?.eventLabel,
          method: this.newsletterDatalayerForm?.data?.eventProperties?.method,
          referral:
            this.newsletterDatalayerForm?.data?.eventProperties?.referral,
        });
      }

      pushEvent({
        event: this.datalayerForm?.data?.eventProperties?.event,
        event_name: this.datalayerForm?.data?.eventProperties?.event_name,
        ecommerce: this.datalayerForm?.data?.eventProperties?.ecommerce,
        eventCategory: this.datalayerForm?.data?.eventProperties?.eventCategory,
        eventAction: this.datalayerForm?.data?.eventProperties?.eventAction,
        eventLabel: this.datalayerForm?.data?.eventProperties?.eventLabel,
        method: this.datalayerForm?.data?.eventProperties?.method,
        referral: this.datalayerForm?.data?.eventProperties?.referral,
      });
    },
    pushReturnTag() {
      pushEvent({
        event: 'uaevent',
        ecommerce: 'undefined',
        eventCategory: 'appendix',
        eventAction: 'select::vch-create-account',
        eventLabel: `${this.confirmButtonText.toLowerCase()}::${
          window.location.origin
        }`,
        event_name: 'body_button_click',
        cta_name: `${this.confirmButtonText.toLowerCase()}`,
        link_url: `${window.location.origin}`,
        module_name: 'vch-create-account',
      });
    },
  },
};
</script>

<style lang="scss" src="./create-account.scss"></style>
